module.exports = __webpack_public_path__ + "img/phoxSupport.e3577528.png";